<template>
  <section class="tight" style="padding-top: 0">
    <div class="wrap">
      <p style="text-align:center; color:var(--t-2); font-family:var(--f-mono); font-size:12px; letter-spacing:0.15em; text-transform:uppercase; margin-bottom:20px;">
        {{ labelsState['lv_logos_title'] || 'Companies already communicating better with NQA' }}
      </p>
      <div class="logos">
        <div>ACME◐</div>
        <div>Lumen·co</div>
        <div>NORTH/STAR</div>
        <div>flora.</div>
        <div>VELOCE</div>
        <div>orbital™</div>
        <div>kairós</div>
      </div>
    </div>
  </section>
</template>

<script>
import { computed, onMounted } from 'vue';
import { useLabelsStore } from '@/stores/labels';
import { useLanguageStore } from '@/stores/language';

export default {
  name: 'LogosV2',
  setup() {
    const labelsStore = useLabelsStore();
    const languageStore = useLanguageStore();
    onMounted(() => labelsStore.fetchAndSetLabels(languageStore.language));
    return { labelsState: computed(() => labelsStore.labels) };
  },
};
</script>
